import cx from 'classnames';

import bullsImg from 'assets/bg/bg.jpeg';

import styles from './index.module.css';

function AuthContainerLayout({ children, bgImage }) {
  return (
    <div className={cx(styles.container, 'custom-gp-auth-layout-container')}>
      <img className={styles.bg} src={bgImage || bullsImg} alt="Background Image" crossOrigin="" />
      <div className={cx(styles.content, 'custom-gp-auth-layout-content')}>
        <div className={cx(styles.margin, 'custom-gp-auth-layout-margin')} />
        <div className={cx(styles.card, 'custom-gp-auth-layout-card')}>{children}</div>
        <div className={cx(styles.margin, 'custom-gp-auth-layout-margin')} />
      </div>
    </div>
  );
}

export default AuthContainerLayout;
